<template>
    <ul class="online-chat-form">
        <li class="online-chat-items">
            <div class="other-img avator"></div>
            <span class="other-text text-style">
                 {{multyLang[currentConfig.welcomeText]?multyLang[currentConfig.welcomeText][currentTranslateCode]:""}}
            </span>
        </li>
        <li class="other online-chat-items">
            <template>
                <img class="other-img avator" :src="avatorSrc" alt="">
            </template>
            <div class="online-other-form">
                <template v-show="!hasSubmit">
                    <p class="form-des">
                        {{multyLang[currentConfig.formIntro]?multyLang[currentConfig.formIntro][currentTranslateCode]:""}}
                    </p>
                    <div ref="createForm" label-width="0px"
                             class="create-field--forms el-form">
                        <div
                            class="el-form-item"
                            style="position: relative"
                            v-for="(item,index) in onLineForm"
                            :prop="item.key"
                            :rule="computedRules(item)"
                        >
                            <div v-if="item.type=='custom'&&item.list.length>0">
                                <ul class="chooseItem">
                                    <p class="choose-title">Select a required item</p>
                                    <el-radio-group v-model="radio">
                                        <li class="choose-input" v-for="(i,j) in item.list">
                                            <el-radio :label="i.key">
                                                <create-form :item="i" @changRadio="changRadio" :currentform="customForm"
                                                             v-model="customForm[i.key]" :isCustom="true"></create-form>
                                            </el-radio>
                                        </li>
                                    </el-radio-group>
                                </ul>
                            </div>
                            <create-form v-else :item="item" v-model="currentForms[item.key]"
                                         :currentform="currentForms"></create-form>
                        </div>
                    </div>
                    <div class="form-submit"  @click="conversionTriggerFn">
                        <hz-button :loading="loading" type="primary" size="mini" id="hz_online_sub_btn" @click="submitForm"
                                   class="el-button sub-btn el-button--primary el-button--small"
                                   :style="{backgroundColor:currentConfig.submitBtnColor}">{{multyLang&&multyLang[currentConfig.submitBtnText.replace(' ','')]?multyLang[currentConfig.submitBtnText.replace(' ','')][currentTranslateCode]:'start chat'}}
                        </hz-button>
                    </div>
                </template>

            </div>
        </li>

    </ul>
</template>


<script>
    import {baseChatUrl, baseUrl_1, baseUrl_8} from "../config/env";
    import CreateForm from "./createForm";
    import AsyncValidator from 'async-validator'
    import {store,mutations} from "../store/index";
    import HzButton from "./button";
    import {creatConversionDiv} from "@/util/util";

    export default {
        name: 'chatForm',
        components: {CreateForm,HzButton},
        data() {
            return {
                radio: 3,
                currentForms: {},
                rules: {},
                customForm: {},
                currentValidIndex: 0,
                validArr: [],
                customRules: {},
                hasSubmit:false,
                loading:false,
                formMsgList:[],
            }
        },
        props: {
            avatorSrc:{
                type:String,
                default:''
            },
            item:{
                type:Object,
                default(){
                    return {}
                }
            }

        },
        created() {
            let _this = this;
            this.getCluesField(_this.onLineForm, _this.currentForms);

        },
        mounted(){
            let ele = document.getElementById('hzchat-list-box');
            if (ele) {
                setTimeout(()=>{
                    ele.scrollTop = ele.scrollHeight;
                },500)
            }
        },
        computed:{
            multyLang(){
                return store.multyLang
            },
            currentTranslateCode(){
                return store.currentTranslateCode
            },
            currentConfig(){
                return store.onlineConfig
            },
            onlineFormId(){
                return store.onlineFormId
            },
            onLineForm(){
                return store.onLineForm
            },
            conversionConfigId() {
              return store.conversionConfigId;
            },
        },

        methods: {
            conversionTriggerFn() {
              if(this.conversionConfigId == 3 || this.conversionConfigId == 4) {
                creatConversionDiv();
              }
            },
            computedRules(item) {
                let arr = [];
                let message = this.multyLang[item.placeholder]&&this.multyLang[item.placeholder][this.currentTranslateCode]?this.multyLang[item.placeholder][this.currentTranslateCode]:'please input'
                if (item.required == 1 || item.required) {
                    if (item.type == 'text') {
                        let requireObj = {required: true, message: message, trigger: 'blur'};
                        arr.push(requireObj);
                    } else {
                        let requireObj = {required: true, message: message, trigger: 'change'};
                        arr.push(requireObj);
                    }
                }
                if (item.hasOwnProperty('validate') && item.validate && item.validate.rule.length > 0) {
                    arr.concat(item.validate.rule)
                }
                if (item.hasOwnProperty('key') && !this.rules[item.key]) {
                    this.rules[item.key] = arr;
                }
                if (item.type == 'custom' && item.list.length > 0) {
                    item.list.forEach((i, j) => {
                        let brr = []
                        if (i.hasOwnProperty('validate') && i.validate && i.validate.rule.length > 0) {
                            brr.concat(i.validate.rule);
                            customRules[i.key] = [].concat(brr);
                        }
                    })
                }
                return arr
            },
            getCluesField(list, obj) {
                let _this = this;
                list.forEach((item, index) => {
                    if (!obj[item.key]) {
                        if (item.type == 'multipleText') {
                            obj[item.key] = [''];
                        } else if (item.type == 'multipleSelect') {
                            obj[item.key] = [{
                                key: "",
                                value: ""
                            }]
                        } else if (item.type == 'custom') {
                            _this.getCluesField(item.list, _this.customForm)

                        } else if(item.type == 'checkbox'){
                            obj[item.key] = ''
                        }else {
                            obj[item.key] = ''
                        }
                    }
                })
                obj = Object.assign({}, obj);
                console.info('obj', obj);
            },

            addOptions(key, flag) {
                if (flag == 'select') {
                    this.currentForms[key].push({
                        key: '',
                        value: ''
                    })
                } else {
                    this.currentForms[key].push('')
                }

            },
            removeOptions(key, index) {
                this.currentForms[key].splice(index, 1);
            },
            submitForm() {

                let _this = this;
                this.currentValidIndex = 0;

                this.valiaField();
                let customForm =  this.customForm;
                for(var i in customForm){
                    if(customForm[i]){
                        _this.currentForms[i] = customForm[i]
                    }
                }
                let params = Object.assign({}, _this.currentForms, {
                    messagePage: window.location.href,
                    formId: this.onlineFormId,
                    companyId:utilConfig.enterpriseId,
                    visitorSource: 0,
                    serverId: window.utilConfig.serverId,
                    [_this.radio]: this.customForm[_this.radio]
                })

                this.validate(() => {


                    _this.formMsgList = [];
                    _this.onLineForm.forEach((item,index)=>{    //转成时期格式，方便筛选

                        if(item.key=='custom6666'&&item.list&&item.list.length>0){
                            item.list.forEach((ii,jj)=>{
                                if(ii.type=='date'||ii.type=='datetime'){
                                    if(params[ii.key].length>0){
                                        params[ii.key] = new Date(Number(params[ii.key]))
                                    }
                                }
                                _this.setFormMsg(ii);
                            })
                        }

                        if(item.type=='date'||item.type=='datetime'){
                            if(params[item.key].length>0){
                                params[item.key] = new Date(Number(params[item.key]))
                            }
                        }



                        _this.setFormMsg(item);
                    })
                    _this.loading = true;
                    console.info( _this.formMsgList);

                    hzAjax({
                        url:baseUrl_8 + '/message/' + utilConfig.visitorid,
                        type: "PUT",
                        contentType:"application/json",
                        data: JSON.stringify(params),
                        success:function (res) {
                            _this.loading = false;
                            if (res.code == _this.$successCode) {
                                try{
                                    _this.$message(_this.multyLang['提交成功'][_this.currentTranslateCode], 'success');
                                }catch (e) {
                                    _this.$message("success")
                                }
                                _this.hasSubmit = true;
                                mutations.SubOnlineForm();
                                /*给客服发送消息*/
                                _this.sendFormMsgFn()

                            }else{
                                _this.$message(res.info);
                            }
                        }
                    })
                })
                // this.checkForms();
            },

            setFormMsg(item){
                let _this = this;
                if(_this.currentForms.hasOwnProperty(item.key)){
                    if(item.type=='radio'||item.type == 'select'){
                        item.options.forEach((i, j) => {
                            if (i.key == _this.currentForms[item.key]) {
                                // _this.sendFormMsg[item.key] = i.value;
                                _this.formMsgList.push({
                                    key:item.key,
                                    value:i.value,
                                    label:item.label,
                                    type:item.type,
                                })
                            }
                        })
                    }else if(item.type == 'multipleSelect'){
                        // let arr = _this.currentForms[item.key];
                        // let label = ''
                        // if (arr) {
                        //     arr.forEach((_item, _index) => {
                        //         if (item.options.some((i, j) => {
                        //             label = i.value;
                        //             return _item.key === i.key;
                        //         })) {
                        //             value = label + ' ' + _item.value + ';' + value;
                        //         }
                        //     })
                        // }
                    }else if(item.type=='checkbox') {
                        if (_this.currentForms[item.key] && typeof _this.currentForms[item.key] == 'string') {
                            let keyValue = _this.currentForms[item.key].split(',');
                            let value = [];
                            if (item.hasOwnProperty('options') && item.options instanceof Array) {
                                item.options.forEach((i, j) => {
                                    let key = i.key + ''
                                    if (keyValue.indexOf(key) >= 0) {
                                        value.push(i.value)
                                    }
                                })
                                _this.formMsgList.push({
                                    key:item.key,
                                    value:value,
                                    label:item.label,
                                    type:item.type,
                                })

                                // _this.sendFormMsg[item.key] = value;
                            }
                        }
                    }else {
                        _this.formMsgList.push({
                            key:item.key,
                            value:_this.currentForms[item.key],
                            label:item.label,
                            type:item.type,
                        })
                    }
                }
            },

            dealArrayValue(val) {
                if (val===undefined||val===null) {
                    return
                }
                if (typeof val == 'object') {
                    return val.join(',')
                } else {
                    return val
                }
            },

            sendFormMsgFn(){
                let _this = this;
                // this.sendFormMsg.formId =  this.onlineFormId;
                // this.sendFormMsg.companyId = utilConfig.enterpriseId;
                mutations.sendCustomMsg({
                    type:"onlineform",
                    txt:JSON.stringify(_this.formMsgList)
                })
            },
            valiaField() {
                this.validArr = [];
                let _this = this;
                this.onLineForm.forEach((item, index) => {
                    if (item.required == 1 || item.hasOwnProperty('key') && !this.rules[item.key].length > 0 && item.type != 'custom') {   //需要校验
                        if (item.type == 'multipleText' || item.type == 'multipleSelect') {
                            for (var i = 0; i < _this.currentForms[item.key].length; i++) {
                                this.validArr.push({
                                    prop: item.key + '[' + i + ']',
                                    obj: item,
                                    key: item.key,
                                    value: _this.currentForms[item.key][i]
                                })
                            }

                        } else {
                            if (item.type !== 'custom') {
                                this.validArr.push({
                                    prop: item.key,
                                    key: item.key,
                                    value: _this.currentForms[item.key]+''
                                })
                            }
                        }
                    } else if (item.type == 'custom') {
                        // 自定义的先不做校验
                        this.validArr.push({
                            prop: 'custom666',
                            key: 'custom666',
                            data: item.list||[],
                            value: _this.customForm
                        })

                    }
                })
            },
            validate(callback) {
                let _this = this;
                let currentItem = this.validArr[_this.currentValidIndex];
                if (currentItem.key != 'custom666') {
                    let ruleItem = _this.rules[currentItem.key];
                    let formRules = {};
                    if (ruleItem.length > 0) {
                        formRules[currentItem.prop] = ruleItem;
                        const validator = new AsyncValidator(formRules);
                        validator.validate({[currentItem.prop]: currentItem.value}, (errors, fields) => {
                            if (errors) {
                                _this.$message(errors[0].message);
                            } else {
                                if (_this.currentValidIndex < _this.onLineForm.length - 1) {
                                    _this.currentValidIndex++;
                                    _this.validate(callback);
                                } else {
                                    typeof callback == 'function' && callback()
                                }
                            }
                        })
                    } else {
                        if (_this.currentValidIndex < _this.onLineForm.length - 1) {
                            _this.currentValidIndex++;
                            _this.validate(callback);
                        } else {
                            typeof callback == 'function' && callback()
                        }
                    }
                } else {
                    if (currentItem.data.length == 0) {
                        if (_this.currentValidIndex < _this.onLineForm.length - 1) {
                            _this.currentValidIndex++;
                            _this.validate(callback);
                        } else {
                            typeof callback == 'function' && callback()
                        }
                    }else{
                        let flag = false;
                        for (var i in currentItem.value) {
                            if (currentItem.value[i].length > 0) {
                                flag = true
                            }
                        }
                        if (flag) {
                            if (_this.currentValidIndex < _this.onLineForm.length - 1) {
                                _this.currentValidIndex++;
                                _this.validate(callback);
                            } else {
                                typeof callback == 'function' && callback()
                            }
                        } else {
                            try {
                                _this.$message(_this.multyLang["任选一项需要填写"][_this.currentTranslateCode]);
                            }catch (e) {
                                console.info(e)
                                _this.$message('Please select any item to fill in')
                            }                        }
                    }

                }
            },

            // checkForms() {
            //     let _this = this;
            //     let flag = true;
            //     let currentItem = this.onLineForm[_this.currentValidIndex];
            //     if (currentItem.key !== 'custom') {
            //         let ruleItem = _this.rules[currentItem.key];
            //         let formRules = {};
            //         if (ruleItem.length > 0) {
            //             formRules[currentItem.key] = ruleItem;
            //         } else {
            //             _this.currentValidIndex++;
            //         }
            //
            //     } else if (currentItem.key == 'multipleText') {
            //         let ruleItem = _this.rules[currentItem.key];
            //         let formRules = {};
            //         if (ruleItem.length > 0) {
            //             formRules[currentItem.key] = ruleItem;
            //             const validator = new AsyncValidator(formRules);
            //             validator.validate({[currentItem.key]: _this.currentForms[currentItem.key]}, (errors, fields) => {
            //                 if (errors) {
            //                     _this.$message(errors[0].message);
            //                 } else {
            //                     if (_this.currentValidIndex < _this.onLineForm.length - 1) {
            //                         _this.currentValidIndex++;
            //                         this.checkForms();
            //                     } else {
            //                         // _this.$message("校验完成");
            //                     }
            //                 }
            //             })
            //         } else {
            //             _this.currentValidIndex++;
            //         }
            //
            //     } else if (currentItem.key == 'multipleSelect') {
            //
            //     } else {
            //         _this.currentValidIndex++;
            //     }
            // },

            changRadio(val) {
                this.radio = val;
            },
        }
    }
</script>


<style lang="scss">
    #hz_chat_app{
        .online-chat-form {
            padding: 16px 0;
            overflow: hidden;
            width: 100%;
            .online-chat-items {
                margin: 0 auto;
                margin-bottom: 16px;
                text-align: left;
                /*width: 335px;*/
            }
            /*.hz-form-item .is_required{*/
                /*left: 3px;*/
            /*}*/
            .other-text {
                margin-left: 0px;
            }
            .text-style {
                background: #E6EAF2;
                box-shadow: none;
                margin-left: 8px;
            }
            .online-other-form {
                width: 300px;
                height: auto;
                background: #fff;
                border-radius: 3px;
                border: 1px solid #E9E9E9;
                display: inline-block;
                margin-left: 8px;
                position: relative;
                /*margin: 0 auto;*/
                transition: all 0.28s;
                -webkit-box-shadow: 0 2px 8px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .1), inset 0 2px 0 0 rgba(48, 71, 236, 0.5);
                box-shadow: 0 2px 8px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .1), inset 0 2px 0 0 rgba(48, 71, 236, 0.5);
            }
            .online-other-form:hover{
                -webkit-box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .1), inset 0 2px 0 0 rgba(48, 71, 236, 0.5);
                box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .1), inset 0 2px 0 0 rgba(48, 71, 236, 0.5);
            }


            .online-other-form .form-des {
                width: 100%;
                font-size: 14px;
                font-family: SFUIText-Regular, SFUIText;
                font-weight: 400;
                color: rgba(3, 15, 30, 1);
                line-height: 20px;
                padding: 10px;
                text-align: left;
            }

            /*.custom-input {*/
                /*width: 262px;*/
                /*height: 40px;*/
                /*background: rgba(255, 255, 255, 1);*/
                /*box-shadow: 2px 2px 3px 0px rgba(0, 0, 0, 0.1);*/
                /*border-radius: 4px;*/
                /*border: 1px solid rgba(217, 217, 217, 1);*/
                /*padding: 0px 5px;*/
            /*}*/

            /*.must-input {*/
                /*margin: 8px auto 12px;*/
                /*text-align: center;*/
                /*position: relative;*/

            /*}*/

            /*.must-input .custom-input {*/
                /*padding-left: 15px;*/
            /*}*/

            /*.must-input:after {*/
                /*position: absolute;*/
                /*right: 10px;*/
                /*top: 0;*/
                /*content: '*';*/
                /*color: #FF4D4F;*/
                /*font-size: 30px;*/
                /*display: inline-block;*/
                /*height: 40px;*/
                /*width: 40px;*/
                /*line-height: 51px;*/
                /*margin-left: 1px;*/
                /*vertical-align: top;*/

            /*}*/

            .choose-input {
                width: 266px;
                background: rgba(255, 255, 255, 1);
                /*box-shadow: 2px 2px 3px 0px rgba(0, 0, 0, 0.1);*/
                border-radius: 4px;
                border: 1px solid rgba(217, 217, 217, 1);
                /*margin: 0 auto;*/
                margin-bottom: 8px;
            }

            .choose-input input {
                /*height: 40px;*/
                /*line-height: 40px;*/
                /*border: none;*/
                /*outline: none;*/
                /*vertical-align: top;*/
            }

            .chooseItem {
                width: 300px;
                padding: 2px 0 8px;
                background: rgba(216, 216, 216, 0.5);
                margin-bottom: 10px;
                padding-left: 17px;
            }

            .choose-title {
                width: 268px;
                font-size: 14px;
                font-family: SFUIText-Regular, SFUIText;
                font-weight: 400;
                color: rgba(3, 15, 30, 1);
                line-height: 20px;
                margin: 11px auto;
            }

            .form-submit {
                width: 262px;
                margin: 0 auto;
                text-align: right;
                padding-bottom: 12px;
            }

            #hz_online_sub_btn {
                background: #428BCA !important;
                padding-left: 20px;
                padding-right: 20px;
                /*width: 100%;*/
            }
        }
       /* .has-submit{
            position: absolute;
            top:0px;
            bottom: 0px;
            left: 0px;
            right: 0px;
            background: #fff;
            text-align: center;

            .has-submit-box{
                height: 100%;
                width: 300px;
                display: table;
                .has-submit-item{
                    vertical-align: middle;
                    display: table-cell;
                    text-align: center;
                    color: #606266;
                }
                .icon-form-img-sucess{
                    font-size: 60px;
                    color: #2FC25B;
                    display: block;
                    margin-bottom: 50px;
                    margin-top: -20px;
                }
                p{
                    line-height: 26px;
                }
            }

        }*/
    }
</style>
<style>
    .el-popper {
        z-index: 9999999 !important;
    }

    .create-field--forms {
        margin-top: 12px;
    }

    .create-field--forms .el-form-item {
        margin-bottom: 0px;
    }

    .choose-input .el-radio__input {
        vertical-align: top;
        margin-left: 10px;
        height: 40px;
        line-height: 40px;

    }

    .other-form .el-radio-group {
        margin: 0 auto;
        display: block;
    }

    /*#hz_chat_app .online-chat-form .hz-form-item .form-item {*/
        /*margin: 0 auto;*/
        /*border-radius: 4px;*/
        /*width: 288px;*/
        /*!*box-shadow: 2px 2px 3px 0px rgba(0, 0, 0, 0.1);*!*/
    /*}*/

</style>
